import { DownloadLink } from "@/components/brand/BrandSection";
import { printMm } from "@/lib/brand";

export const ImageCard = ({ img }) => (
  <article className="overflow-hidden rounded-[28px] border border-sky-100 bg-white" data-testid={`brand-image-${img.file.replace(".jpg", "")}`}>
    <div className="aspect-[4/3] bg-sky-50">
      <img src={`/img/${img.file}`} alt={img.name} loading="lazy" className="h-full w-full object-cover" />
    </div>
    <div className="p-5">
      <h3 className="font-display text-base font-semibold text-ink">{img.name}</h3>
      <p className="mt-1 font-mono text-[12px] text-slate-600">{img.w}×{img.h} px · prints to about {printMm(img.w)}×{printMm(img.h)} mm at 300 dpi</p>
      <div className="mt-4"><DownloadLink href={`/img/${img.file}`} label="JPG" testid={`brand-image-${img.file.replace(".jpg", "")}-download`} /></div>
    </div>
  </article>
);
